module.exports = __webpack_public_path__ + "img/wallet_icon_money.ac6222d0.png";